<template>
  <div class="t-showcase-v4">
    <div class="top-banner">
      <div class="top-banner_wrapper">
        <div class="top-banner__left">
          <div class="top-banner__title">
            <b>Уважаемый пользователь, мы проверили ваши данные.</b> Эти компании готовы предоставить вам средства.
          </div>
          <div class="top-banner__subtitle">
            Мы рекомендуем!
          </div>
          <div class="top-banner__text">
            Оформляйте выдачу сразу в 3–4 компаниях, чтобы получить всю необходимую сумму.
          </div>
        </div>
        <div class="top-banner__right">
          <img src="img/t-showcasev4-banner.png" alt="">
        </div>
      </div>
    </div>
    <div v-if="checkerOffers && checkerOffers.length" class="main-title">
      Лучшие предложения
    </div>
    <div class="checker-card" v-for="checkerOffer in checkerOffers" :key="'checker-' + checkerOffer.id">
      <div class="checker-card__wrapper">
        <div class="checker-card__left">
          <div class="checker-title">
            <div class="checker-title__logo">
              <img :src="'https://zanimakus.ru' + checkerOffer.logo" alt="" />
            </div>
            <div v-if="hasCheckerPrivileges(checkerOffer)" class="checker-title__wrapper">
              <div class="checker-title__text1">
                <img src="/img/fire.png" alt="">
                <span>{{ checkerOffer.privilege1 }}</span>
              </div>
              <div class="checker-title__text2">
                <span>{{ checkerOffer.privilege2 }}</span>
              </div>
            </div>
          </div>
          <div class="checker-name">
            Вам одобрен займ <br>
             в {{ checkerOffer.name }}
          </div>
          <div class="checker-data">
            <div class="checker-data__text">
              <div>Сумма:</div> <span>{{ numberFormat(checkerOffer.amount) }} ₽</span>
            </div>
            <div class="checker-data__text">
              <div>Срок:</div> <span>{{ checkerOffer.period }} дн.</span>
            </div>
            <div class="checker-data__text">
              <div>Ставка:</div> <span>{{ getCheckerPercentValue(checkerOffer) }} %</span>
            </div>
          </div>
          <div v-if="hasCheckerPrivileges(checkerOffer)" class="checker-title__wrapper__mob">
            <div class="checker-title__text1">
              <img src="/img/fire.png" alt="">
              <span>{{ checkerOffer.privilege1 }}</span>
            </div>
            <div class="checker-title__text2">
              <span>{{ checkerOffer.privilege2 }}</span>
            </div>
          </div>
          <div @click="openLinks(checkerOffer)" class="checker-button">
            <button>ПОЛУЧИТЬ ДЕНЬГИ</button>
          </div>
          <div class="checker-info">
            {{ checkerOffer.legal_info }}
          </div>
        </div>
        <div class="checker-card__right">
          <img src="/img/t-showcasev4-man.png" alt="">
        </div>
      </div>
    </div>
    <div class="main-title">Также для вас</div>

    <template v-if="isSwiperEnabled">
      <div class="showcase-wrapper">
        <div class="swiper-pagination" ref="pagination"></div>
        <div class="swiper-text__label">Листайте влево</div>
        <div class="swiper showcase-swiper" ref="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="offer in mobileSwiperDisplayOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link || offer.name">
              <div class="card">
                <div class="card-top">
                  <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
                </div>

                <div class="offer-name">{{ offer.name }}</div>

                <div class="card-info">
                  <div class="card-info__wrapper">
                    <div class="card-info__img"><img src="/img/t-showcasev4-sum.svg" alt=""></div>
                    <div class="card-info__value">Сумма - до {{ numberFormat(offer.amount) }} ₽</div>
                  </div>

                  <div class="card-info__wrapper">
                    <div class="card-info__img"><img src="/img/t-showcasev4-period.svg" alt=""></div>
                    <div class="card-info__value">Срок - до {{ offer.period }} дней</div>
                  </div>

                  <div class="card-info__wrapper">
                    <div class="card-info__img"><img src="/img/t-showcasev4-percent.svg" alt=""></div>
                    <div class="card-info__value">
                      Без % — <span v-if="offer.without_percent">да</span><span v-else>нет</span>
                    </div>
                  </div>
                </div>

                <div class="card-btn" @click="openLinks(offer)">
                  <button type="button">Отправить заявку</button>
                </div>

                <div class="card-info__rate">
                  <star-rating :max="5" :current="offer.rating"></star-rating>
                </div>
              </div>
            </div>
          </div>

          <button
            class="showcase-nav prev"
            type="button"
            :class="{ hidden: !hasMovedFromFirst }"
            ref="prevBtn"
          >‹</button>
          <button
            class="showcase-nav next"
            type="button"
            ref="nextBtn"
          >›</button>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="showcase-wrapper showcase-wrapper--no-swiper">
        <div class="card" v-for="offer in filteredOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
          <div class="card-top">
            <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
          </div>

          <div class="offer-name">{{ offer.name }}</div>

          <div class="card-info">
            <div class="card-info__wrapper">
              <div class="card-info__img"><img src="/img/t-showcasev4-sum.svg" alt=""></div>
              <div class="card-info__value">Сумма - до {{ numberFormat(offer.amount) }} ₽</div>
            </div>

            <div class="card-info__wrapper">
              <div class="card-info__img"><img src="/img/t-showcasev4-period.svg" alt=""></div>
              <div class="card-info__value">Срок - до {{ offer.period }} дней</div>
            </div>

            <div class="card-info__wrapper">
              <div class="card-info__img"><img src="/img/t-showcasev4-percent.svg" alt=""></div>
              <div class="card-info__value">
                Без % — <span v-if="offer.without_percent">да</span><span v-else>нет</span>
              </div>
            </div>
          </div>

          <div class="card-btn" @click="openLinks(offer)">
            <button type="button">Отправить заявку</button>
          </div>

          <div class="card-info__rate">
            <star-rating :max="5" :current="offer.rating"></star-rating>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import * as Functions from "../assets/js/functions.js";
import StarRating from "@/components/StarRating";
import mobileSwiperMixin from "../assets/js/mobileSwiperMixin.js";

export default {
  mixins: [mobileSwiperMixin],
  name: "TemplatesShowcaseV4",
  components: { StarRating },

  props: {
    offers: Array,
    mainOffers: Array,
    sortingOffers: Array,
    reserveOffers: Array,
    activePrimaryBucket: String,
    checkerOffers: Array,
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    displayedOffers: [],
    reservePool: [],
    nextReplaceIndex: 0,
    replaceTimerId: null,
    isReplacementShown: false,
  }),

  computed: {
    checkerOfferKeys() {
      return new Set(
        (this.checkerOffers || [])
          .map(this.getOfferKey)
          .filter(Boolean)
      );
    },

    filteredOffers() {
      return this.displayedOffers || [];
    },

    mainOffersSource() {
      return (this.mainOffers && this.mainOffers.length ? this.mainOffers : this.offers) || [];
    },

    sortingOffersSource() {
      return this.sortingOffers || [];
    },

    filteredPrimaryOffersSource() {
      const mainOffers = this.excludeCheckerOffers(this.mainOffersSource);

      if (mainOffers.length > 0) {
        return mainOffers;
      }

      return this.excludeCheckerOffers(this.offers || this.sortingOffersSource);
    },

    filteredReplacementOffersSource() {
      const primaryOfferKeys = new Set(this.filteredPrimaryOffersSource.map(this.getOfferKey).filter(Boolean));
      const replacementOffers = [
        ...(this.sortingOffersSource || []),
        ...(this.reserveOffers || []),
      ];

      return this.excludeCheckerOffers(replacementOffers).filter((offer) => {
        const key = this.getOfferKey(offer);

        if (!key) return true;

        return !primaryOfferKeys.has(key);
      });
    },

    replaceTimerSeconds() {
      const value = Number(this.settings?.offers_replace_timer);

      if (!Number.isFinite(value) || value <= 0) {
        return 0;
      }

      return value;
    },

  },

  watch: {

    filteredPrimaryOffersSource: {
      handler() {
        this.syncOfferPools();
      },
      immediate: true,
    },

    filteredReplacementOffersSource() {
      this.syncOfferPools();
    },

    replaceTimerSeconds() {
      this.restartOfferRotation();
    },
  },

  beforeUnmount() {
    this.stopOfferRotation();
  },

  methods: {
    normalizeCheckerPrivilege(value) {
      return String(value ?? "").replace(/[\s\u00A0\u200B-\u200D\uFEFF]+/g, "").trim();
    },

    hasCheckerPrivileges(checkerOffer) {
      const privilege1 = this.normalizeCheckerPrivilege(checkerOffer?.privilege1);
      const privilege2 = this.normalizeCheckerPrivilege(checkerOffer?.privilege2);

      return privilege1 !== "" && privilege2 !== "";
    },

    getFallbackCheckerPercent(checkerOffer) {
      const variants = ["0", "0.1", "0.3", "0.5", "0.7", "0.9", "1"];
      const seed = this.getOfferKey(checkerOffer) || "checker-percent";
      let hash = 0;

      for (let index = 0; index < seed.length; index += 1) {
        hash = (hash * 31 + seed.charCodeAt(index)) >>> 0;
      }

      return variants[hash % variants.length];
    },

    getCheckerPercentValue(checkerOffer) {
      const percent = this.normalizeCheckerPrivilege(checkerOffer?.percent_mfo);
      return percent !== "" ? percent : this.getFallbackCheckerPercent(checkerOffer);
    },

    excludeCheckerOffers(offers) {
      if (!this.checkerOffers || this.checkerOffers.length === 0) {
        return offers || [];
      }

      return (offers || []).filter((offer) => {
        const key = this.getOfferKey(offer);

        if (!key) return true;

        return !this.checkerOfferKeys.has(key);
      });
    },

    getOfferKey(offer) {
      if (!offer) return null;

      if (offer.id) {
        return `id:${offer.id}`;
      }

      if (offer.link) {
        return `link:${offer.link}`;
      }

      if (offer.name) {
        return `name:${offer.name}|amount:${offer.amount}|period:${offer.period}`;
      }

      return null;
    },

    syncOfferPools() {
      const primaryOffers = [...this.filteredPrimaryOffersSource];
      const replacementOffers = [...this.filteredReplacementOffersSource];

      this.displayedOffers = primaryOffers;
      this.reservePool = replacementOffers;
      this.nextReplaceIndex = 0;
      this.isReplacementShown = false;

      this.restartOfferRotation();
    },

    restartOfferRotation() {
      this.stopOfferRotation();

      if (
        this.replaceTimerSeconds <= 0 ||
        this.displayedOffers.length === 0 ||
        this.reservePool.length === 0
      ) {
        return;
      }

      this.replaceTimerId = window.setInterval(() => {
        this.rotateOffersFromReserve();
      }, this.replaceTimerSeconds * 1000);
    },

    stopOfferRotation() {
      if (!this.replaceTimerId) return;

      window.clearInterval(this.replaceTimerId);
      this.replaceTimerId = null;
    },

    rotateOffersFromReserve() {
      if (this.filteredPrimaryOffersSource.length === 0) {
        if (this.reservePool.length > 0) {
          this.displayedOffers = [this.reservePool[0]];
        }
        this.stopOfferRotation();
        return;
      }

      if (this.reservePool.length === 0) {
        this.displayedOffers = [...this.filteredPrimaryOffersSource];
        this.isReplacementShown = false;
        this.stopOfferRotation();
        return;
      }

      const primaryOffers = [...this.filteredPrimaryOffersSource];

      if (!this.isReplacementShown) {
        const replacementOffer = this.reservePool[this.nextReplaceIndex % this.reservePool.length];
        this.displayedOffers = replacementOffer ? [replacementOffer] : [];
        this.isReplacementShown = true;
        return;
      }

      this.displayedOffers = primaryOffers;
      this.isReplacementShown = false;
      this.nextReplaceIndex = (this.nextReplaceIndex + 1) % Math.max(this.reservePool.length, 1);
    },

    numberFormat(n) {
      return Functions.numberFormat(n);
    },

    openLinks(offer) {
      window.open(offer.link, "_blank");
      (offer.links || []).forEach((link) => window.open(link, "_blank"));
    },

  }
};
</script>

<style lang="css">
@import url(../assets/css/t-showcase-v4.scss);
</style>
<style lang="css">
.star-rating {
  width: 50%;
}

.ozzaym .card-info__wrapper {
  display: flex;
  align-items: center;
}

.card-info__rate {
  margin-left: 30px;
  margin-bottom: 15px;
  width: 100%;
}

.swiper-text__label{
  display: none;
}
@media (max-width: 768px) {
  .swiper-text__label{
    display: block;
    font-weight: 400;
    font-size: 16px;
  }
  .showcase-nav.hidden {
    opacity: 0;
    pointer-events: none;
  }
}

.t-showcase-v4 .card-info__wrapper {
  width: 100%;
}

@media (min-width: 768px) {
  .showcase-wrapper>.swiper-pagination,
  .showcase-nav {
    display: none !important;
  }

  .t-showcase-v4 .showcase-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: flex-start;
  }

  .t-showcase-v4 .showcase-swiper .swiper-slide {
    flex: 0 0 355px;
    max-width: 355px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }

  .t-showcase-v4 .showcase-swiper .card {
    width: 100%;
    max-width: 355px;
    box-sizing: border-box;
  }
}

@media (max-width: 767px) {
  .t-showcase-v4 .showcase-wrapper {
    padding: 0 0 20px;
  }

  .t-showcase-v4 .showcase-wrapper--no-swiper {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 0;
    align-items: stretch;
  }

  .t-showcase-v4 .showcase-wrapper--no-swiper .card {
    max-width: 100%;
    width: 100%;
  }

  .t-showcase-v4 .showcase-wrapper--no-swiper .swiper-text__label,
  .t-showcase-v4 .showcase-wrapper--no-swiper .swiper-pagination,
  .t-showcase-v4 .showcase-wrapper--no-swiper .showcase-nav {
    display: none !important;
  }

  .t-showcase-v4 .showcase-wrapper>.swiper-pagination {
    display: block;
    position: relative;
    max-width: 310px;
    width: 100%;
    height: 6px;
    margin: 0 auto 16px;
    background: #e5e5e5;
    border-radius: 999px;
    overflow: hidden;
  }

  .t-showcase-v4 .showcase-wrapper>.swiper-pagination .swiper-pagination-progressbar-fill {
    background: linear-gradient(90deg, #D80000 0%, #F44 100%);
    transform-origin: left center;
    transition: transform .25s ease;
    width: 100%;
    height: 100%;
    transform: scaleX(0);
  }

  .showcase-swiper {
    overflow: visible;
    position: relative;
  }

  .t-showcase-v4 .showcase-carousel {
    overflow: hidden;
    position: relative;
  }

  .t-showcase-v4 .showcase-track {
    display: flex;
    transition: transform .3s ease;
    will-change: transform;
  }

  .t-showcase-v4 .showcase-track--no-transition {
    transition: none;
  }

  .t-showcase-v4 .swiper-slide {
    display: flex;
    justify-content: center;
  }

  .swiper-slide .card {
    max-width: 310px;
    width: 100%;
  }

  .t-showcase-v4 .showcase-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 29px;
    height: 29px;
    color: #fff;
    background: linear-gradient(90deg, #D80000 0%, #F44 100%);
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    cursor: pointer;
  }

  .showcase-nav.prev {
    left: 0px;
  }

  .showcase-nav.next {
    right: 0px;
  }
}

@media (max-width: 430px) {
  .t-showcase-v4 .showcase-wrapper {
    flex-direction: row;
  }

  .t-showcase-v4 .showcase-wrapper--no-swiper {
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    align-items: stretch !important;
  }

  .t-showcase-v4 .showcase-wrapper--no-swiper .card {
    max-width: 100% !important;
    width: 100% !important;
  }
}
</style>
